export const fmtUSD = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "$0";
  const num = Number(n);
  if (Math.abs(num) >= 1_000_000) return `$${(num / 1_000_000).toFixed(2)}M`;
  if (Math.abs(num) >= 1_000) return `$${(num / 1_000).toFixed(1)}K`;
  return `$${num.toFixed(0)}`;
};

export const fmtUSDFull = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(Number(n) || 0);

export const CATEGORY_META = {
  real_estate: { label: "Real Estate", short: "RE", color: "#F59E0B" },
  ecommerce: { label: "E-Commerce", short: "EC", color: "#EAB308" },
  services: { label: "Services", short: "SV", color: "#84CC16" },
  portfolio: { label: "Portfolios", short: "PF", color: "#22D3EE" },
};

export const AGENT_META = {
  scout: { label: "Scout", role: "Opportunities", color: "#3B82F6", cssVar: "--uc-scout" },
  sentinel: { label: "Sentinel", role: "Threats", color: "#EF4444", cssVar: "--uc-sentinel" },
  executor: { label: "Executor", role: "Actions", color: "#22C55E", cssVar: "--uc-executor" },
  auditor: { label: "Auditor", role: "Compliance", color: "#A78BFA", cssVar: "--uc-auditor" },
  strategist: { label: "Strategist", role: "Tax Efficiency", color: "#F59E0B", cssVar: "--uc-strategist" },
  creator: { label: "Creator", role: "Drafts & Copy", color: "#EC4899", cssVar: "--uc-creator" },
  controller: { label: "Controller", role: "Cash & P&L", color: "#14B8A6", cssVar: "--uc-controller" },
};

export const RISK_META = {
  green: { label: "Clean", color: "#22C55E" },
  yellow: { label: "Watch", color: "#F59E0B" },
  red: { label: "Risk", color: "#EF4444" },
};

export const SEVERITY_COLOR = {
  info: "#3B82F6",
  warning: "#F59E0B",
  critical: "#EF4444",
};

export const relativeTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};
